// extracted by mini-css-extract-plugin
export var container = "MoreSalesBanner-module--container--3de33";
export var content = "MoreSalesBanner-module--content--1caa7";
export var cta = "MoreSalesBanner-module--cta--45e08";
export var labels = "MoreSalesBanner-module--labels--80d80";
export var outOfStock = "MoreSalesBanner-module--outOfStock--1315c";
export var price = "MoreSalesBanner-module--price--cb5e7";
export var row = "MoreSalesBanner-module--row--dd108";
export var title = "MoreSalesBanner-module--title--e3a80";
export var withPadding = "MoreSalesBanner-module--withPadding--ae11c";